/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AgricultureIndicators = {
  __typename?: 'AgricultureIndicators';
  agMsmesFinancedResponsibly_companyImpact: StatsAverageDistributionMedianPctl25Pctl75;
  agMsmesFinancedResponsibly_investmentImpact: StatsAverageDistributionMedianPctl25Pctl75;
  agMsmesFinancedResponsibly_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  assetClass: PercentOfTotal;
  assetClass_unique: PercentOfTotal;
  assetsUnderManagement: StatsAverageMedianValues;
  changeInFarmerIncome_companyImpact: StatsAverageDistributionMedianPctl25Pctl75;
  changeInFarmerIncome_investmentImpact: StatsAverageDistributionMedianPctl25Pctl75;
  changeInFarmerIncome_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  countByAssetClass: ValueCount;
  countByBusinessStage: ValueCount;
  countByEcoRegion: ValueCount;
  countByInstrument: ValueCount;
  countByInvesteeSize: ValueCount;
  countByProductPurpose: ValueCount;
  countByProductType: ValueCount;
  countByProviderType: ValueCount;
  countByRegion: ValueCount;
  countByStageValueChain: ValueCount;
  countByYearsSinceInvestment: ValueCount;
  datasetName: Scalars['String']['output'];
  decentJobs_companyImpact: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobs_investmentImpact: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobs_paceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  decentJobs_paceCoLevelPct_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  decentJobs_paceCoLevelPct_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  decentJobs_paceCoLevelPct_grouped: Array<GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen>;
  decentJobs_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  farmerIncome_pctChange: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  farmerIncome_pctChange_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  farmerIncome_pctChange_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  farmerYield_pctChange: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  farmerYield_pctChange_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  farmerYield_pctChange_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  farmersServed_paceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  farmersServed_paceCoLevelPct_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  farmersServed_paceCoLevelPct_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  farmersServed_paceCoLevelPct_grouped: Array<GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen>;
  farmersUsingRAPS_companyImpact: StatsAverageDistributionMedianPctl25Pctl75;
  farmersUsingRAPS_investmentImpact: StatsAverageDistributionMedianPctl25Pctl75;
  farmersUsingRAPS_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  hasSustainablePractices_grouped: Array<GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen>;
  icRacePct: StatsAverage;
  icWomenPct: StatsAverage;
  investeeCountries: PercentOfTotal;
  investeeCountries_unique: PercentOfTotal;
  investeeRevenueGrowth: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  investeeRevenueGrowth_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  investeeRevenueGrowth_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  investeeRevenueGrowth_companyImpact: StatsAverageDistributionMedianPctl25Pctl75;
  investeeRevenueGrowth_grouped: Array<GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen>;
  investeeRevenueGrowth_investmentImpact: StatsAverageDistributionMedianPctl25Pctl75;
  investeeRevenueGrowth_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  investorHeadquartersLocation: PercentOfTotal;
  kpi1_dataConfidence?: Maybe<PercentOfTotal>;
  kpi1_dataCoverage?: Maybe<PercentOfTotal>;
  kpi1_dataMissing?: Maybe<PercentOfTotal>;
  kpi1_demographicImpact_farmersServed_pctWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi1_demographicImpact_farmersServed_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi1_demographicImpact_farmersServed_ruralBasis: StatsAverageMedianUniquen;
  kpi1_demographicImpact_farmersServed_ruralPct?: Maybe<Scalars['Float']['output']>;
  kpi1_demographicImpact_farmersServed_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi1_demographicImpact_farmersServed_women: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi1_demographicImpact_farmersServed_womenBasis: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi1_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi1_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi1_keyFeatures_additionalPractices: PercentOfTotal;
  kpi1_keyFeatures_certificationsInPlace: PercentOfTotal;
  kpi1_keyFeatures_farmersServed: StatsAverageMedian;
  kpi1_keyFeatures_farmersTrained: StatsAverageMedian;
  kpi1_keyFeatures_farmersTrained_investmentLevel: StatsAverageMedian;
  kpi1_keyFeatures_farmersTrained_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi1_keyFeatures_farmersTrained_yearChangeCompany: StatsAverageMedianPctl25Pctl75;
  kpi1_keyFeatures_farmersTrained_yearChangeCompany_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi1_keyFeatures_farmersTrained_yearChange_noOutliers: StatsAverage;
  kpi1_keyFeatures_farmersTrained_yearPctChange: StatsAverageMedianPctl25Pctl75;
  kpi1_keyFeatures_farmersTrained_yearPctChange_noOutliers: StatsAverage;
  kpi1_keyFeatures_normalizationRatio_forFarmersTrained: StatsAverageMedian;
  kpi1_keyFeatures_proportionFarmersTrainedToServed: StatsAverageMedian;
  kpi1_marketSegmentation_assetClass_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_assetClass_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_assetClass_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_assetClass_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_assetClass_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_assetClass_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_countryRegion_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_countryRegion_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_countryRegion_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_countryRegion_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_countryRegion_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_countryRegion_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_stageOfBusiness_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_stageOfBusiness_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_stageOfBusiness_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_stageOfBusiness_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_stageOfBusiness_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_stageOfBusiness_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_targetFinancialReturns_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_targetFinancialReturns_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_targetFinancialReturns_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_targetFinancialReturns_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_marketSegmentation_targetFinancialReturns_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_marketSegmentation_targetFinancialReturns_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_engageInvestees_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_engageInvestees_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_engageInvestees_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_engageInvestees_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_engageInvestees_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_engageInvestees_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_engageStakeholders_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_engageStakeholders_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_engageStakeholders_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_engageStakeholders_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_engageStakeholders_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_engageStakeholders_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_investmentTerms_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_investmentTerms_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_investmentTerms_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_investmentTerms_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_mechanismsUsed_investmentTerms_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_mechanismsUsed_investmentTerms_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_overview_farmersServed: StatsAverageMedian;
  kpi1_overview_farmersServed_investmentLevel: StatsAverageMedian;
  kpi1_overview_farmersServed_pctWomen: StatsAverageMedian;
  kpi1_overview_farmersServed_women: StatsAverageMedian;
  kpi1_overview_farmersServed_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi1_overview_farmersServed_yearChangeCompany: StatsAverageMedianPctl25Pctl75;
  kpi1_overview_farmersServed_yearChangeCompany_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi1_overview_farmersServed_yearChange_noOutliers: StatsAverage;
  kpi1_overview_farmersServed_yearPctChange: StatsAverageMedianPctl25Pctl75;
  kpi1_overview_farmersServed_yearPctChange_noOutliers: StatsAverage;
  kpi1_overview_normalizationRatio: StatsAverageMedian;
  kpi1_performanceOverTime_yearsSinceInvestment_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_performanceOverTime_yearsSinceInvestment_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_performanceOverTime_yearsSinceInvestment_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_performanceOverTime_yearsSinceInvestment_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_performanceOverTime_yearsSinceInvestment_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_performanceOverTime_yearsSinceInvestment_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_ecoRegion_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_ecoRegion_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_ecoRegion_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_ecoRegion_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_ecoRegion_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_ecoRegion_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_investeeType_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_investeeType_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_investeeType_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_investeeType_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_investeeType_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_investeeType_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_productPurpose_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_productPurpose_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_productPurpose_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_productPurpose_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_productPurpose_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_productPurpose_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_productType_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_productType_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_productType_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_productType_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_productType_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_productType_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_valueChainStage_farmersServed: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_valueChainStage_farmersServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_valueChainStage_farmersServedN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_valueChainStage_farmersServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi1_sectorSegmentation_valueChainStage_farmersServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi1_sectorSegmentation_valueChainStage_farmersServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_dataConfidence?: Maybe<PercentOfTotal>;
  kpi2_dataCoverage?: Maybe<PercentOfTotal>;
  kpi2_dataMissing?: Maybe<PercentOfTotal>;
  kpi2_demographicImpact_msmesServed: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi2_demographicImpact_msmesServed_pctWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi2_demographicImpact_msmesServed_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi2_demographicImpact_msmesServed_ruralBasis: StatsAverageMedianUniquen;
  kpi2_demographicImpact_msmesServed_ruralPct?: Maybe<Scalars['Float']['output']>;
  kpi2_demographicImpact_msmesServed_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi2_demographicImpact_msmesServed_women: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi2_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi2_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi2_keyFeatures_additionalPractices: Array<GroupStatsUniquen>;
  kpi2_marketSegmentation_assetClass_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_assetClass_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_assetClass_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_assetClass_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_assetClass_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_assetClass_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_countryRegion_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_countryRegion_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_countryRegion_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_countryRegion_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_countryRegion_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_countryRegion_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_stageOfBusiness_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_stageOfBusiness_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_stageOfBusiness_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_stageOfBusiness_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_stageOfBusiness_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_stageOfBusiness_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_targetFinancialReturns_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_targetFinancialReturns_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_targetFinancialReturns_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_targetFinancialReturns_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_marketSegmentation_targetFinancialReturns_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_marketSegmentation_targetFinancialReturns_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_engageInvestees_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_engageInvestees_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_engageInvestees_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_engageInvestees_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_engageInvestees_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_engageInvestees_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_engageStakeholders_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_engageStakeholders_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_engageStakeholders_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_engageStakeholders_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_engageStakeholders_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_engageStakeholders_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_investmentTerms_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_investmentTerms_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_investmentTerms_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_investmentTerms_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_mechanismsUsed_investmentTerms_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_mechanismsUsed_investmentTerms_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_overview_msmesServed: StatsAverageDistributionMedian;
  kpi2_overview_msmesServed_investmentLevel: StatsAverageMedian;
  kpi2_overview_msmesServed_pctWomen: StatsAverageMedian;
  kpi2_overview_msmesServed_women: StatsAverageMedian;
  kpi2_overview_msmesServed_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi2_overview_msmesServed_yearChange_noOutliers: StatsAverage;
  kpi2_overview_msmesServed_yearPctChange: StatsAverageMedianPctl25Pctl75;
  kpi2_overview_msmesServed_yearPctChange_noOutliers: StatsAverage;
  kpi2_overview_normalizationRatio: StatsAverageMedian;
  kpi2_performanceOverTime_yearsSinceInvestment_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_performanceOverTime_yearsSinceInvestment_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_performanceOverTime_yearsSinceInvestment_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_performanceOverTime_yearsSinceInvestment_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_performanceOverTime_yearsSinceInvestment_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_performanceOverTime_yearsSinceInvestment_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_ecoRegion_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_ecoRegion_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_ecoRegion_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_ecoRegion_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_ecoRegion_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_ecoRegion_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_investeeType_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_investeeType_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_investeeType_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_investeeType_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_investeeType_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_investeeType_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_productPurpose_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_productPurpose_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_productPurpose_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_productPurpose_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_productPurpose_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_productPurpose_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_productType_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_productType_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_productType_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_productType_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_productType_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_productType_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_valueChainStage_msmesServed: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_valueChainStage_msmesServedN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_valueChainStage_msmesServedN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_valueChainStage_msmesServedPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi2_sectorSegmentation_valueChainStage_msmesServedPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi2_sectorSegmentation_valueChainStage_msmesServed_noOutliers: Array<GroupStatsAverage>;
  kpi3_dataConfidence?: Maybe<PercentOfTotal>;
  kpi3_dataCoverage?: Maybe<PercentOfTotal>;
  kpi3_dataMissing?: Maybe<PercentOfTotal>;
  kpi3_demographicImpact_paymentsMade_histMarg: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi3_demographicImpact_paymentsMade_histMargBasis: StatsAverageMedianUniquen;
  kpi3_demographicImpact_paymentsMade_histMargPct: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi3_demographicImpact_paymentsMade_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi3_demographicImpact_paymentsMade_ruralBasis: StatsAverageMedianUniquen;
  kpi3_demographicImpact_paymentsMade_ruralPct?: Maybe<Scalars['Float']['output']>;
  kpi3_demographicImpact_paymentsMade_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi3_demographicImpact_paymentsMade_women: StatsAverageMedianUniquen;
  kpi3_demographicImpact_paymentsMade_womenBasis: StatsAverageMedianUniquen;
  kpi3_demographicImpact_paymentsMade_womenDist: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi3_demographicImpact_paymentsMade_womenPct: StatsAverageMedianUniquen;
  kpi3_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi3_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi3_keyFeatures_normalizationRatio: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_investmentLevel: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_pctWomen: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_pctWomen_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_yearChange_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_yearPctChange: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_paymentsMade_yearPctChange_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_pctChangeFarmerYield: StatsAverageMedianPctl25Pctl75;
  kpi3_keyFeatures_pctChangeFarmerYield_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi3_marketSegmentation_assetClass_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_marketSegmentation_assetClass_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_marketSegmentation_countryRegion_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_marketSegmentation_countryRegion_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_marketSegmentation_stageOfBusiness_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_marketSegmentation_stageOfBusiness_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_marketSegmentation_targetFinancialReturns_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_marketSegmentation_targetFinancialReturns_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_mechanismsUsed_engageInvestees_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_mechanismsUsed_engageInvestees_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_mechanismsUsed_engageStakeholders_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_mechanismsUsed_engageStakeholders_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_mechanismsUsed_investmentTerms_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_mechanismsUsed_investmentTerms_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_overview_pctChangeFarmerIncome: StatsAverageMedianPctl25Pctl75;
  kpi3_overview_pctChangeFarmerIncome_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi3_performanceOverTime_yearsSinceInvestment_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_performanceOverTime_yearsSinceInvestment_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_sectorSegmentation_ecoRegion_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_sectorSegmentation_ecoRegion_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_sectorSegmentation_investeeType_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_sectorSegmentation_investeeType_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_sectorSegmentation_productPurpose_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_sectorSegmentation_productPurpose_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_sectorSegmentation_productType_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_sectorSegmentation_productType_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi3_sectorSegmentation_valueChainStage_pctChangeInFarmerIncome: Array<GroupStatsAverageMedianUniquen>;
  kpi3_sectorSegmentation_valueChainStage_pctChangeInFarmerIncome_noOutliers: Array<GroupStatsAverage>;
  kpi4_dataConfidence?: Maybe<PercentOfTotal>;
  kpi4_dataCoverage?: Maybe<PercentOfTotal>;
  kpi4_dataMissing?: Maybe<PercentOfTotal>;
  kpi4_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi4_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi4_keyFeatures_certificationsInPlace: PercentOfTotal;
  kpi4_keyFeatures_certificationsInPlace_: PercentOfTotal;
  kpi4_keyFeatures_directlyManagedLand: StatsAverageMedian;
  kpi4_keyFeatures_indirectlyManagedLand: StatsAverageMedian;
  kpi4_keyFeatures_sustainablePractices: PercentOfTotal;
  kpi4_marketSegmentation_assetClass_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_assetClass_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_assetClass_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_assetClass_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_assetClass_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_assetClass_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_countryRegion_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_countryRegion_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_countryRegion_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_countryRegion_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_countryRegion_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_countryRegion_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_stageOfBusiness_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_stageOfBusiness_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_stageOfBusiness_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_stageOfBusiness_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_stageOfBusiness_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_stageOfBusiness_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_targetFinancialReturns_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_targetFinancialReturns_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_targetFinancialReturns_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_targetFinancialReturns_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_marketSegmentation_targetFinancialReturns_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_marketSegmentation_targetFinancialReturns_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_engageInvestees_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_engageInvestees_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_engageInvestees_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_engageInvestees_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_engageInvestees_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_engageInvestees_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_engageStakeholders_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_engageStakeholders_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_engageStakeholders_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_engageStakeholders_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_engageStakeholders_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_engageStakeholders_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_investmentTerms_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_investmentTerms_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_investmentTerms_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_investmentTerms_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_mechanismsUsed_investmentTerms_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_mechanismsUsed_investmentTerms_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_overview_landTotal: StatsAverageMedian;
  kpi4_overview_landTotal_investmentLevel: StatsAverageMedian;
  kpi4_overview_landTotal_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi4_overview_landTotal_yearChangeCompany: StatsAverageMedianPctl25Pctl75;
  kpi4_overview_landTotal_yearChangeCompany_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi4_overview_landTotal_yearChange_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi4_overview_landTotal_yearPctChange: StatsAverageMedianPctl25Pctl75;
  kpi4_overview_normalizationRatio: StatsAverageMedian;
  kpi4_performanceOverTime_yearsSinceInvestment_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_performanceOverTime_yearsSinceInvestment_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_performanceOverTime_yearsSinceInvestment_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_performanceOverTime_yearsSinceInvestment_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_performanceOverTime_yearsSinceInvestment_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_performanceOverTime_yearsSinceInvestment_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_ecoRegion_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_ecoRegion_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_ecoRegion_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_ecoRegion_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_ecoRegion_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_ecoRegion_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_investeeType_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_investeeType_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_investeeType_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_investeeType_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_investeeType_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_investeeType_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_productPurpose_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_productPurpose_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_productPurpose_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_productPurpose_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_productPurpose_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_productPurpose_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_productType_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_productType_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_productType_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_productType_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_productType_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_productType_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_valueChainStage_landTotal: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_valueChainStage_landTotalN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_valueChainStage_landTotalN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_valueChainStage_landTotalPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi4_sectorSegmentation_valueChainStage_landTotalPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi4_sectorSegmentation_valueChainStage_landTotal_noOutliers: Array<GroupStatsAverage>;
  kpi6_dataConfidence?: Maybe<PercentOfTotal>;
  kpi6_dataCoverage?: Maybe<PercentOfTotal>;
  kpi6_dataMissing?: Maybe<PercentOfTotal>;
  kpi6_demographicImpact_decentJobs: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi6_demographicImpact_decentJobs_pctWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi6_demographicImpact_decentJobs_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi6_demographicImpact_decentJobs_ruralBasis: StatsAverageMedianUniquen;
  kpi6_demographicImpact_decentJobs_ruralPct?: Maybe<Scalars['Float']['output']>;
  kpi6_demographicImpact_decentJobs_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi6_demographicImpact_decentJobs_women: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi6_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi6_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi6_marketSegmentation_assetClass_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_assetClass_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_assetClass_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_assetClass_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_assetClass_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_assetClass_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_countryRegion_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_countryRegion_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_countryRegion_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_countryRegion_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_countryRegion_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_countryRegion_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_stageOfBusiness_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_stageOfBusiness_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_stageOfBusiness_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_stageOfBusiness_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_stageOfBusiness_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_stageOfBusiness_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_targetFinancialReturns_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_targetFinancialReturns_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_targetFinancialReturns_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_targetFinancialReturns_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_marketSegmentation_targetFinancialReturns_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_marketSegmentation_targetFinancialReturns_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_engageInvestees_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_engageInvestees_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_engageInvestees_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_engageInvestees_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_engageInvestees_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_engageInvestees_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_engageStakeholders_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_engageStakeholders_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_engageStakeholders_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_engageStakeholders_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_engageStakeholders_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_engageStakeholders_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_investmentTerms_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_investmentTerms_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_investmentTerms_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_investmentTerms_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_mechanismsUsed_investmentTerms_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_mechanismsUsed_investmentTerms_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_overview_decentJobs: StatsAverageMedianValues;
  kpi6_overview_decentJobs_investmentLevel: StatsAverageMedian;
  kpi6_overview_decentJobs_pctWomen: StatsAverageMedian;
  kpi6_overview_decentJobs_women: StatsAverageMedian;
  kpi6_overview_decentJobs_yearChange: StatsAverageMedianPctl25Pctl75;
  kpi6_overview_decentJobs_yearChangeCompany: StatsAverageMedianPctl25Pctl75;
  kpi6_overview_decentJobs_yearChangeCompany_noOutliers: StatsAverageMedianPctl25Pctl75;
  kpi6_overview_decentJobs_yearChange_noOutliers: StatsAverage;
  kpi6_overview_decentJobs_yearPctChange: StatsAverageMedianPctl25Pctl75;
  kpi6_overview_decentJobs_yearPctChange_noOutliers: StatsAverage;
  kpi6_overview_normalizationRatio: StatsAverageMedian;
  kpi6_performanceOverTime_yearsSinceInvestment_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_performanceOverTime_yearsSinceInvestment_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_performanceOverTime_yearsSinceInvestment_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_performanceOverTime_yearsSinceInvestment_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_performanceOverTime_yearsSinceInvestment_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_performanceOverTime_yearsSinceInvestment_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_ecoRegion_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_ecoRegion_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_ecoRegion_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_ecoRegion_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_ecoRegion_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_ecoRegion_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_investeeType_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_investeeType_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_investeeType_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_investeeType_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_investeeType_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_investeeType_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_productPurpose_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_productPurpose_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_productPurpose_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_productPurpose_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_productPurpose_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_productPurpose_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_productType_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_productType_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_productType_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_productType_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_productType_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_productType_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_valueChainStage_decentJobs: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_valueChainStage_decentJobsN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_valueChainStage_decentJobsN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_valueChainStage_decentJobsPaceN: Array<GroupStatsAverageMedianUniquen>;
  kpi6_sectorSegmentation_valueChainStage_decentJobsPaceN_noOutliers: Array<GroupStatsAverage>;
  kpi6_sectorSegmentation_valueChainStage_decentJobs_noOutliers: Array<GroupStatsAverage>;
  kpi7_dataConfidence?: Maybe<PercentOfTotal>;
  kpi7_dataCoverage?: Maybe<PercentOfTotal>;
  kpi7_dataMissing?: Maybe<PercentOfTotal>;
  kpi7_demographicImpact_investeeRevenueGrowth: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi7_demographicImpact_investeeRevenueGrowth_majorityWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi7_demographicImpact_investeeRevenueGrowth_majorityWomenPct?: Maybe<Scalars['Float']['output']>;
  kpi7_demographicImpact_investeeRevenueGrowth_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi7_demographicImpact_investeeRevenueGrowth_ruralPct?: Maybe<Scalars['Float']['output']>;
  kpi7_demographicImpact_investeeRevenueGrowth_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  kpi7_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi7_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi7_marketSegmentation_assetClass_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_marketSegmentation_assetClass_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_marketSegmentation_countryRegion_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_marketSegmentation_countryRegion_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_marketSegmentation_stageOfBusiness_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_marketSegmentation_stageOfBusiness_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_marketSegmentation_targetFinancialReturns_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_marketSegmentation_targetFinancialReturns_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_mechanismsUsed_engageInvestees_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_mechanismsUsed_engageInvestees_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_mechanismsUsed_engageStakeholders_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_mechanismsUsed_engageStakeholders_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_mechanismsUsed_investmentTerms_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_mechanismsUsed_investmentTerms_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_overview_investeeRevenueGrowth: StatsAverageMedianPctl25Pctl75;
  kpi7_overview_investeeRevenueGrowth_leastDeveloped: StatsAverageMedianPctl25Pctl75;
  kpi7_overview_investeeRevenueGrowth_mostDeveloped: StatsAverageMedianPctl25Pctl75;
  kpi7_performanceOverTime_yearsSinceInvestment_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_performanceOverTime_yearsSinceInvestment_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_sectorSegmentation_ecoRegion_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_sectorSegmentation_ecoRegion_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_sectorSegmentation_investeeType_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_sectorSegmentation_investeeType_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_sectorSegmentation_productPurpose_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_sectorSegmentation_productPurpose_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_sectorSegmentation_productType_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_sectorSegmentation_productType_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  kpi7_sectorSegmentation_valueChainStage_investeeRevenueGrowth: Array<GroupStatsAverageMedianUniquen>;
  kpi7_sectorSegmentation_valueChainStage_investeeRevenueGrowth_noOutliers: Array<GroupStatsAverage>;
  landTotal_paceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  landTotal_paceCoLevelPct_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  landTotal_paceCoLevelPct_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  msmesServed_paceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen;
  msmesServed_paceCoLevelPct_byCountry: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  msmesServed_paceCoLevelPct_byRegion: Array<GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen>;
  msmesServed_paceCoLevelPct_grouped: Array<GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen>;
  numberOfFunds: Scalars['Int']['output'];
  numberOfInvestees: Scalars['Int']['output'];
  numberOfObservations?: Maybe<Scalars['Int']['output']>;
  numberOfOrgs: Scalars['Int']['output'];
  pctChangeFarmerIncome_grouped: Array<GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen>;
  productPurpose: PercentOfTotal;
  productPurpose_unique: PercentOfTotal;
  productType: PercentOfTotal;
  productType_unique: PercentOfTotal;
  reportingPeriod: ExtentsInt;
  sdgs: PercentOfTotal;
  sdgs_unique: PercentOfTotal;
  stageValueChain: PercentOfTotal;
  stageValueChain_unique: PercentOfTotal;
  strategicGoals: PercentOfTotal;
  strategicGoals_unique: PercentOfTotal;
  sustainablyManagedLand_companyImpact: StatsAverageDistributionMedianPctl25Pctl75;
  sustainablyManagedLand_investmentImpact: StatsAverageDistributionMedianPctl25Pctl75;
  sustainablyManagedLand_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  targetFinancialReturns: PercentOfTotal;
  targetFinancialReturns_unique: PercentOfTotal;
};


export type AgricultureIndicatorsDecentJobs_PaceCoLevelPct_GroupedArgs = {
  groupBy?: InputMaybe<GroupByEnum>;
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgricultureIndicatorsFarmersServed_PaceCoLevelPct_GroupedArgs = {
  groupBy?: InputMaybe<GroupByEnum>;
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgricultureIndicatorsHasSustainablePractices_GroupedArgs = {
  groupBy?: InputMaybe<GroupByEnum>;
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgricultureIndicatorsInvesteeRevenueGrowth_GroupedArgs = {
  groupBy?: InputMaybe<GroupByEnum>;
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgricultureIndicatorsMsmesServed_PaceCoLevelPct_GroupedArgs = {
  groupBy?: InputMaybe<GroupByEnum>;
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AgricultureIndicatorsPctChangeFarmerIncome_GroupedArgs = {
  groupBy?: InputMaybe<GroupByEnum>;
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnergyIndicators = {
  __typename?: 'EnergyIndicators';
  activeClients: StatsAverageDistributionMedianPctl25Pctl75;
  activeClientsHistMarg: StatsDistributionMedian;
  activeClientsHistMarg_noOutliers: StatsAverage;
  activeClientsN: StatsAverageDistributionMedianPctl25Pctl75;
  activeClientsN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  activeClientsN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  activeClientsN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  activeClientsNorm: StatsAverage;
  activeClientsPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  activeClientsPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  activeClientsPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_noOutliers: StatsAverage;
  activeClientsPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceCoLevel_noOutliers: StatsAverage;
  activeClientsPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  activeClientsPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_noOutliers: StatsAverage;
  activeClientsPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  activeClientsPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  activeClientsPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  activeClientsPctHistMarg: StatsDistributionMedian;
  activeClientsPctHistMarg_noOutliers: StatsAverage;
  activeClientsPctPoor: StatsDistributionMedian;
  activeClientsPctPoor_noOutliers: StatsAverage;
  activeClientsPctWomen: StatsDistributionMedian;
  activeClientsPctWomen_noOutliers: StatsAverage;
  activeClientsPoor: StatsDistributionMedian;
  activeClientsPoor_noOutliers: StatsAverage;
  activeClientsWomen: StatsDistributionMedian;
  activeClientsWomen_noOutliers: StatsAverage;
  activeClients_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  activeClients_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  activeClients_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  activeClients_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  activeClients_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  activeClients_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  activeClients_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  activeClients_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  activeClients_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  activeClients_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  activeClients_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  activeClients_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  activeClients_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  activeClients_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  activeClients_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  activeClients_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  activeClients_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  activeClients_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  activeClients_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  activeClients_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  activeClients_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  activeClients_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  activeClients_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  activeClients_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  activeClients_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  activeClients_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  activeClients_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  activeClients_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  assetClass: PercentOfTotal;
  assetClass_unique: PercentOfTotal;
  assetsUnderManagement: StatsAverageMedian;
  clientsWithSavings: StatsAverageDistributionMedianPctl25Pctl75;
  clientsWithSavingsN: StatsAverageDistributionMedianPctl25Pctl75;
  clientsWithSavingsN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsNorm: StatsAverage;
  clientsWithSavingsPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  clientsWithSavingsPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_noOutliers: StatsAverage;
  clientsWithSavingsPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceCoLevel_noOutliers: StatsAverage;
  clientsWithSavingsPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  clientsWithSavingsPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_noOutliers: StatsAverage;
  clientsWithSavingsPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavingsPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  clientsWithSavings_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  clientsWithSavings_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  countByAssetClass: ValueCount;
  countByBusinessStage: ValueCount;
  countByEmissionsAvoidedMethod: ValueCount;
  countByInstrument: ValueCount;
  countByInvesteeSize: ValueCount;
  countByMarketSaturation: ValueCount;
  countByOnOrOffGrid: ValueCount;
  countByPrimaryClient: ValueCount;
  countByPrimaryCountry: ValueCount;
  countByPrimaryEnergySource: ValueCount;
  countByProductType: ValueCount;
  countByProviderType: ValueCount;
  countByRegion: ValueCount;
  countByStageValueChain: ValueCount;
  countByYearsSinceInvestment: ValueCount;
  datasetName: Scalars['String']['output'];
  decentJobs: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobsN: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobsN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  decentJobsN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  decentJobsN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  decentJobsNorm: StatsAverage;
  decentJobsPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobsPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobsPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_noOutliers: StatsAverage;
  decentJobsPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceCoLevel_noOutliers: StatsAverage;
  decentJobsPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobsPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_noOutliers: StatsAverage;
  decentJobsPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  decentJobsPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  decentJobsPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  decentJobs_developedMarket: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobs_developedMarket_noOutliers: StatsAverage;
  decentJobs_emergingMarket: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobs_emergingMarket_noOutliers: StatsAverage;
  decentJobs_leastDeveloped: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobs_leastDeveloped_noOutliers: StatsAverage;
  decentJobs_majorityWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  decentJobs_majorityWomenPct?: Maybe<Scalars['Float']['output']>;
  decentJobs_majorityWomen_noOutliers: StatsAverage;
  decentJobs_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  decentJobs_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  decentJobs_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  decentJobs_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  decentJobs_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  decentJobs_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  decentJobs_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  decentJobs_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  decentJobs_mostDeveloped: StatsAverageDistributionMedianPctl25Pctl75;
  decentJobs_mostDeveloped_noOutliers: StatsAverage;
  decentJobs_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  decentJobs_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  decentJobs_ruralPct?: Maybe<Scalars['Float']['output']>;
  decentJobs_rural_noOutliers: StatsAverage;
  decentJobs_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  decentJobs_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  decentJobs_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  decentJobs_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  decentJobs_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  decentJobs_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  decentJobs_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  decentJobs_urban_noOutliers: StatsAverage;
  emissionsAvoided: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsAvoidedMethod: PercentOfTotal;
  emissionsAvoidedN: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsAvoidedN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedNorm: StatsAverage;
  emissionsAvoidedPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsAvoidedPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_noOutliers: StatsAverage;
  emissionsAvoidedPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceCoLevel_noOutliers: StatsAverage;
  emissionsAvoidedPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsAvoidedPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_noOutliers: StatsAverage;
  emissionsAvoidedPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoidedPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsAvoided_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsAvoided_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2N: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2N_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2N_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2N_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2Norm: StatsAverage;
  emissionsScope1And2PaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2PaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_noOutliers: StatsAverage;
  emissionsScope1And2PaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceCoLevel_noOutliers: StatsAverage;
  emissionsScope1And2PaceN: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2PaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_noOutliers: StatsAverage;
  emissionsScope1And2PaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2PaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_developedMarket: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2_developedMarket_noOutliers: StatsAverage;
  emissionsScope1And2_emergingMarket: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2_emergingMarket_noOutliers: StatsAverage;
  emissionsScope1And2_leastDeveloped: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2_leastDeveloped_noOutliers: StatsAverage;
  emissionsScope1And2_majorityWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  emissionsScope1And2_majorityWomenPct?: Maybe<Scalars['Float']['output']>;
  emissionsScope1And2_majorityWomen_noOutliers: StatsAverage;
  emissionsScope1And2_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_mostDeveloped: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1And2_mostDeveloped_noOutliers: StatsAverage;
  emissionsScope1And2_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  emissionsScope1And2_ruralPct?: Maybe<Scalars['Float']['output']>;
  emissionsScope1And2_rural_noOutliers: StatsAverage;
  emissionsScope1And2_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1And2_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1And2_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  emissionsScope1And2_urban_noOutliers: StatsAverage;
  emissionsScope1N: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1N_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1N_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1N_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1Norm: StatsAverage;
  emissionsScope1PaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1PaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1PaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_noOutliers: StatsAverage;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceCoLevel_noOutliers: StatsAverage;
  emissionsScope1PaceN: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope1PaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_noOutliers: StatsAverage;
  emissionsScope1PaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1PaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1PaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope1_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope1_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope2N: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope2N_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2N_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2N_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2Norm: StatsAverage;
  emissionsScope2PaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope2PaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope2PaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_noOutliers: StatsAverage;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceCoLevel_noOutliers: StatsAverage;
  emissionsScope2PaceN: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope2PaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_noOutliers: StatsAverage;
  emissionsScope2PaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2PaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2PaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope2_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope2_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope3N: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope3N_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3N_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3N_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3Norm: StatsAverage;
  emissionsScope3PaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope3PaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope3PaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_noOutliers: StatsAverage;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceCoLevel_noOutliers: StatsAverage;
  emissionsScope3PaceN: StatsAverageDistributionMedianPctl25Pctl75;
  emissionsScope3PaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_noOutliers: StatsAverage;
  emissionsScope3PaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3PaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3PaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  emissionsScope3_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  emissionsScope3_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyLost: StatsAverageDistributionMedianPctl25Pctl75;
  energyLostN: StatsAverageDistributionMedianPctl25Pctl75;
  energyLostN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyLostN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyLostN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyLostN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyLostN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyLostN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyLostN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyLostN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyLostN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyLostN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyLostN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyLostNorm: StatsAverage;
  energyLostPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  energyLostPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  energyLostPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_noOutliers: StatsAverage;
  energyLostPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceCoLevel_noOutliers: StatsAverage;
  energyLostPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  energyLostPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_noOutliers: StatsAverage;
  energyLostPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyLostPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyLostPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyLost_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyLost_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyLost_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyLost_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyLost_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyLost_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyLost_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyLost_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyLost_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyLost_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyLost_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyLost_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyLost_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyLost_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyLost_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyLost_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyLost_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyLost_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyLost_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyLost_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyProduced: StatsAverageDistributionMedianPctl25Pctl75;
  energyProducedN: StatsAverageDistributionMedianPctl25Pctl75;
  energyProducedN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyProducedN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyProducedN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyProducedNorm: StatsAverage;
  energyProducedPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  energyProducedPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  energyProducedPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_noOutliers: StatsAverage;
  energyProducedPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceCoLevel_noOutliers: StatsAverage;
  energyProducedPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  energyProducedPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_noOutliers: StatsAverage;
  energyProducedPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyProducedPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyProducedPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyProduced_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyProduced_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyProduced_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyProduced_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyProduced_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyProduced_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyProduced_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyProduced_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyProduced_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyProduced_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyProduced_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyProduced_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyProduced_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyProduced_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyProduced_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyStad: StatsAverageDistributionMedianPctl25Pctl75;
  energyStadN: StatsAverageDistributionMedianPctl25Pctl75;
  energyStadN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyStadN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyStadN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyStadN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyStadN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyStadN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyStadN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyStadN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyStadN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyStadN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyStadN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyStadN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyStadN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyStadN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyStadN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyStadNorm: StatsAverage;
  energyStadPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  energyStadPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  energyStadPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_noOutliers: StatsAverage;
  energyStadPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceCoLevel_noOutliers: StatsAverage;
  energyStadPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  energyStadPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_noOutliers: StatsAverage;
  energyStadPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyStadPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyStadPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  energyStad_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  energyStad_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  energyStad_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  energyStad_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  energyStad_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  energyStad_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  energyStad_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  energyStad_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  energyStad_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  energyStad_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  energyStad_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  energyStad_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  energyStad_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  energyStad_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  energyStad_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  energyStad_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  energyStad_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  energyStad_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  energyStad_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  energyStad_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  energyStad_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  energyStad_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  energyStad_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  energyStad_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  energyStad_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  energyStad_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  energyStad_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  energyStad_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  icMeanHistMargPct: StatsAverage;
  icMeanWomenPct: StatsAverage;
  investeeRevenueGrowth: StatsAverageDistributionMedianPctl25Pctl75;
  investeeRevenueGrowthN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceCoLevelPct_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowthPaceN_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_leastDeveloped: StatsAverageMedianPctl25Pctl75;
  investeeRevenueGrowth_majorityWomen: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  investeeRevenueGrowth_majorityWomenPct?: Maybe<Scalars['Float']['output']>;
  investeeRevenueGrowth_marketSegmentation_assetClass: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_marketSegmentation_assetClass_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_marketSegmentation_countryRegion: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_marketSegmentation_countryRegion_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_marketSegmentation_investmentStage: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_marketSegmentation_investmentStage_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_marketSegmentation_marketSaturation: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_marketSegmentation_marketSaturation_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_marketSegmentation_targetFinancialReturns: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_marketSegmentation_targetFinancialReturns_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_mechanismsUsed_engageInvestees: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_mechanismsUsed_engageInvestees_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_mechanismsUsed_engageStakeholders: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_mechanismsUsed_engageStakeholders_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_mechanismsUsed_investmentTerms: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_mechanismsUsed_investmentTerms_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_mostDeveloped: StatsAverageMedianPctl25Pctl75;
  investeeRevenueGrowth_performanceOverTime_yearsSinceInvestment: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_performanceOverTime_yearsSinceInvestment_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_rural: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  investeeRevenueGrowth_ruralPct?: Maybe<Scalars['Float']['output']>;
  investeeRevenueGrowth_sectorSegmentation_onOrOffGrid: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_sectorSegmentation_onOrOffGrid_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_sectorSegmentation_primaryClient: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_sectorSegmentation_primaryClient_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_sectorSegmentation_primaryEnergySource: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_sectorSegmentation_primaryEnergySource_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_sectorSegmentation_primaryProductType: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_sectorSegmentation_primaryProductType_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_sectorSegmentation_primaryStageEnergySupply: Array<GroupStatsAverageMedianUniquen>;
  investeeRevenueGrowth_sectorSegmentation_primaryStageEnergySupply_noOutliers: Array<GroupStatsAverage>;
  investeeRevenueGrowth_urban: StatsAverageDistributionMedianPctl25Pctl75Uniquen;
  investmentStage: PercentOfTotal;
  investmentStage_unique: PercentOfTotal;
  investorHeadquartersLocation: PercentOfTotal;
  kpi1_dataConfidence?: Maybe<PercentOfTotal>;
  kpi1_dataCoverage?: Maybe<PercentOfTotal>;
  kpi1_dataMissing?: Maybe<PercentOfTotal>;
  kpi1_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi1_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi2_dataConfidence?: Maybe<PercentOfTotal>;
  kpi2_dataCoverage?: Maybe<PercentOfTotal>;
  kpi2_dataMissing?: Maybe<PercentOfTotal>;
  kpi2_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi2_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi3_dataConfidence?: Maybe<PercentOfTotal>;
  kpi3_dataCoverage?: Maybe<PercentOfTotal>;
  kpi3_dataMissing?: Maybe<PercentOfTotal>;
  kpi3_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi3_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi4_dataConfidence?: Maybe<PercentOfTotal>;
  kpi4_dataCoverage?: Maybe<PercentOfTotal>;
  kpi4_dataMissing?: Maybe<PercentOfTotal>;
  kpi4_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi4_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi5_dataConfidence?: Maybe<PercentOfTotal>;
  kpi5_dataCoverage?: Maybe<PercentOfTotal>;
  kpi5_dataMissing?: Maybe<PercentOfTotal>;
  kpi5_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi5_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi6_dataConfidence?: Maybe<PercentOfTotal>;
  kpi6_dataCoverage?: Maybe<PercentOfTotal>;
  kpi6_dataMissing?: Maybe<PercentOfTotal>;
  kpi6_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi6_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi7_dataConfidence?: Maybe<PercentOfTotal>;
  kpi7_dataCoverage?: Maybe<PercentOfTotal>;
  kpi7_dataMissing?: Maybe<PercentOfTotal>;
  kpi7_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi7_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  kpi8_dataConfidence?: Maybe<PercentOfTotal>;
  kpi8_dataCoverage?: Maybe<PercentOfTotal>;
  kpi8_dataMissing?: Maybe<PercentOfTotal>;
  kpi8_investorContribution_engagingInvestees: Array<GroupStatsUniquenPctn>;
  kpi8_investorContribution_engagingStakeholders: Array<GroupStatsUniquenPctn>;
  marketSaturation: PercentOfTotal;
  marketSaturation_unique: PercentOfTotal;
  numberConnections: StatsAverageDistributionMedianPctl25Pctl75;
  numberConnectionsN: StatsAverageDistributionMedianPctl25Pctl75;
  numberConnectionsNorm: StatsAverage;
  numberConnectionsPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  numberConnectionsPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  numberConnectionsPaceCoLevelPct_noOutliers: StatsAverage;
  numberConnectionsPaceCoLevel_noOutliers: StatsAverage;
  numberConnectionsPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  numberConnectionsPaceN_noOutliers: StatsAverage;
  numberOfFunds: Scalars['Int']['output'];
  numberOfInvestees: Scalars['Int']['output'];
  numberOfOrgs: Scalars['Int']['output'];
  onOrOffGrid: PercentOfTotal;
  onOrOffGrid_unique: PercentOfTotal;
  overviewActiveClientsPctWomen: StatsAverageMedian;
  overviewActiveClientsWomen: StatsAverageMedian;
  primaryClient: PercentOfTotal;
  primaryClient_unique: PercentOfTotal;
  primaryCountry: PercentOfTotal;
  primaryCountry_unique: PercentOfTotal;
  primaryEnergySource: PercentOfTotal;
  primaryEnergySource_unique: PercentOfTotal;
  primaryProductType: PercentOfTotal;
  primaryProductType_unique: PercentOfTotal;
  qualityAssuranceMechanisms: PercentOfTotal;
  reportingPeriod: ExtentsInt;
  sdgs: PercentOfTotal;
  sdgs_unique: PercentOfTotal;
  stageInValueChain: PercentOfTotal;
  stageInValueChain_unique: PercentOfTotal;
  strategicGoals: PercentOfTotal;
  strategicGoals_unique: PercentOfTotal;
  targetFinancialReturns: PercentOfTotal;
  targetFinancialReturns_unique: PercentOfTotal;
  unitsSold: StatsAverageDistributionMedianPctl25Pctl75;
  unitsSoldN: StatsAverageDistributionMedianPctl25Pctl75;
  unitsSoldNorm: StatsAverage;
  unitsSoldPaceCoLevel: StatsAverageDistributionMedianPctl25Pctl75;
  unitsSoldPaceCoLevelPct: StatsAverageDistributionMedianPctl25Pctl75;
  unitsSoldPaceCoLevelPct_noOutliers: StatsAverage;
  unitsSoldPaceCoLevel_noOutliers: StatsAverage;
  unitsSoldPaceN: StatsAverageDistributionMedianPctl25Pctl75;
  unitsSoldPaceN_noOutliers: StatsAverage;
};


export type EnergyIndicatorsActiveClientsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClientsPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsActiveClients_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavingsPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsClientsWithSavings_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobsPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_DevelopedMarketArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_EmergingMarketArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_LeastDevelopedArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MajorityWomenArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_MostDevelopedArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_RuralArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsDecentJobs_UrbanArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoidedPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsAvoided_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1Args = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2Args = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2NArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2N_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2NormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2PaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_DevelopedMarketArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_EmergingMarketArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_LeastDevelopedArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MajorityWomenArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_MostDevelopedArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_RuralArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1And2_UrbanArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1NArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1N_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1NormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1PaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope1_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2Args = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2NArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2N_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2NormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2PaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope2_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3Args = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3NArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3N_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3NormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3PaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEmissionsScope3_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLostPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyLost_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProducedPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyProduced_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStadPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsEnergyStad_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceCoLevelPct_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowthPaceN_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MarketSegmentation_AssetClassArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MarketSegmentation_CountryRegionArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MarketSegmentation_InvestmentStageArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MarketSegmentation_MarketSaturationArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MarketSegmentation_TargetFinancialReturnsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MechanismsUsed_EngageInvesteesArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MechanismsUsed_EngageStakeholdersArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_MechanismsUsed_InvestmentTermsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_PerformanceOverTime_YearsSinceInvestmentArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_SectorSegmentation_OnOrOffGridArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_SectorSegmentation_PrimaryClientArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_SectorSegmentation_PrimaryEnergySourceArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_SectorSegmentation_PrimaryProductTypeArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsInvesteeRevenueGrowth_SectorSegmentation_PrimaryStageEnergySupplyArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsNumberConnectionsArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsNumberConnectionsNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsNumberConnectionsNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsNumberConnectionsPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsNumberConnectionsPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsNumberConnectionsPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsUnitsSoldArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsUnitsSoldNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsUnitsSoldNormArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsUnitsSoldPaceCoLevelArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsUnitsSoldPaceCoLevelPctArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnergyIndicatorsUnitsSoldPaceNArgs = {
  includeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExtentsInt = {
  __typename?: 'ExtentsInt';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type FilterCond = {
  field: FilterField;
  group?: InputMaybe<Scalars['String']['input']>;
  op: FilterOp;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum FilterField {
  AssetClass = 'assetClass',
  BusinessStage = 'businessStage',
  EcoRegion = 'ecoRegion',
  EmissionsAvoidedMethod = 'emissionsAvoidedMethod',
  ForestType = 'forestType',
  ImpactStrategy = 'impactStrategy',
  IncomeGroup = 'incomeGroup',
  InvesteeSize = 'investeeSize',
  MarketSaturation = 'marketSaturation',
  Observation = 'observation',
  OnOffGrid = 'onOffGrid',
  Org = 'org',
  PrimaryClient = 'primaryClient',
  PrimaryCountry = 'primaryCountry',
  PrimaryEnergySource = 'primaryEnergySource',
  PrimaryProductType = 'primaryProductType',
  ProductPurpose = 'productPurpose',
  ProductType = 'productType',
  ProviderType = 'providerType',
  Region = 'region',
  SettingOfCare = 'settingOfCare',
  StageOfBusiness = 'stageOfBusiness',
  StageValueChain = 'stageValueChain',
  YearsSinceInvestment = 'yearsSinceInvestment'
}

export enum FilterOp {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne'
}

export type FinanceIndicators = {
  __typename?: 'FinanceIndicators';
  assetClass: PercentOfTotal;
  assetClass_byCompany: PercentOfTotal;
  assetsUnderManagement: StatsAverageMedian;
  clientSatisfactionRatio_companyImpact: StatsAverageMedian;
  clientSatisfactionRatio_investmentImpact: StatsAverageMedian;
  clientSatisfactionRatio_yearChange: StatsAverageDistributionMedian;
  clientsAccessingBasicServices_companyImpact: StatsAverageMedian;
  clientsAccessingBasicServices_investmentImpact: StatsAverageMedian;
  clientsAccessingBasicServices_yearChange: StatsAverageDistributionMedian;
  clientsUsingRFS_companyImpact: StatsAverageMedian;
  clientsUsingRFS_investmentImpact: StatsAverageMedian;
  clientsUsingRFS_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  countByBucketsSinceInvestment: ValueCount;
  countByBusinessStage: ValueCount;
  countByInstrument: ValueCount;
  countByInvesteeEngagement: ValueCount;
  countByInvestmentTerms: ValueCount;
  countByProviderType: ValueCount;
  countByRegion: ValueCount;
  countByStakeholderEngagement: ValueCount;
  countByYearsSinceInvestment: ValueCount;
  datasetName: Scalars['String']['output'];
  decentJobs_companyImpact: StatsAverageMedian;
  decentJobs_investmentImpact: StatsAverageMedian;
  decentJobs_yearChange: StatsAverageDistributionMedian;
  icRacePct: StatsAverage;
  icWomenPct: StatsAverage;
  investeeCountries?: Maybe<PercentOfTotal>;
  investeeRevenueGrowth_companyImpact: StatsAverageMedian;
  investeeRevenueGrowth_investmentImpact: StatsAverageMedian;
  investeeRevenueGrowth_yearChange: StatsAverageDistributionMedian;
  investorHeadquartersLocation: PercentOfTotal;
  kpi1_clients: StatsAverageMedian;
  kpi1_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi1_dataCoverage?: Maybe<PercentOfTotal>;
  kpi1_dataQuality?: Maybe<PercentOfTotal>;
  kpi1_missingData?: Maybe<PercentOfTotal>;
  kpi1_paceCo: StatsAverageMedianPctl25Pctl75;
  kpi1_paceN: StatsAverageMedianPctl25Pctl75;
  kpi1_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi1_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi1_pace_byInstrument?: Maybe<GroupStats>;
  kpi1_pace_byProviderType?: Maybe<GroupStats>;
  kpi1_pace_byRegion?: Maybe<GroupStats>;
  kpi1_usingRFS_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi1_usingRFS_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi1_usingRFS_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi1_weightedClients: StatsAverageMedian;
  kpi1_weightedPctStake: StatsAverage;
  kpi2_basicServices_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi2_basicServices_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi2_basicServices_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi2_clients: StatsAverageMedian;
  kpi2_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi2_dataCoverage?: Maybe<PercentOfTotal>;
  kpi2_dataQuality?: Maybe<PercentOfTotal>;
  kpi2_missingData?: Maybe<PercentOfTotal>;
  kpi2_paceCo: StatsAverageMedianPctl25Pctl75;
  kpi2_paceN: StatsAverageMedianPctl25Pctl75;
  kpi2_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi2_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi2_pace_byInstrument?: Maybe<GroupStats>;
  kpi2_pace_byProviderType?: Maybe<GroupStats>;
  kpi2_pace_byRegion?: Maybe<GroupStats>;
  kpi2_weightedClients: StatsAverageMedian;
  kpi2_weightedPctStake: StatsAverage;
  kpi3_dataCoverage?: Maybe<PercentOfTotal>;
  kpi3_dataQuality?: Maybe<PercentOfTotal>;
  kpi3_missingData?: Maybe<PercentOfTotal>;
  kpi4_dataCoverage?: Maybe<PercentOfTotal>;
  kpi4_dataQuality?: Maybe<PercentOfTotal>;
  kpi4_missingData?: Maybe<PercentOfTotal>;
  kpi4_satisfaction: StatsAverageMedianPctl25Pctl75;
  kpi4_satisfaction_buckets: ValueCount;
  kpi4_satisfaction_byBusinessStage?: Maybe<GroupStats>;
  kpi4_satisfaction_byInstrument?: Maybe<GroupStats>;
  kpi4_satisfaction_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi4_satisfaction_byProviderType?: Maybe<GroupStats>;
  kpi4_satisfaction_byRegion?: Maybe<GroupStats>;
  kpi4_satisfaction_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi4_satisfaction_byTerms?: Maybe<GroupStats>;
  kpi4_satisfaction_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi5_clients: StatsAverageMedian;
  kpi5_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi5_dataCoverage?: Maybe<PercentOfTotal>;
  kpi5_dataQuality?: Maybe<PercentOfTotal>;
  kpi5_missingData?: Maybe<PercentOfTotal>;
  kpi5_msmes_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi5_msmes_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi5_msmes_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi5_paceN: StatsAverageMedianPctl25Pctl75;
  kpi5_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi5_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi5_pace_byInstrument?: Maybe<GroupStats>;
  kpi5_pace_byProviderType?: Maybe<GroupStats>;
  kpi5_pace_byRegion?: Maybe<GroupStats>;
  kpi5_weightedClients: StatsAverageMedian;
  kpi5_weightedPctStake: StatsAverage;
  kpi6_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi6_dataCoverage?: Maybe<PercentOfTotal>;
  kpi6_dataQuality?: Maybe<PercentOfTotal>;
  kpi6_decentJobs: StatsAverageMedian;
  kpi6_decentJobs_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi6_decentJobs_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi6_decentJobs_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi6_missingData?: Maybe<PercentOfTotal>;
  kpi6_paceCo: StatsAverageMedianPctl25Pctl75;
  kpi6_paceN: StatsAverageMedianPctl25Pctl75;
  kpi6_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi6_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi6_pace_byInstrument?: Maybe<GroupStats>;
  kpi6_pace_byProviderType?: Maybe<GroupStats>;
  kpi6_pace_byRegion?: Maybe<GroupStats>;
  kpi6_weightedJobs: StatsAverageMedian;
  kpi6_weightedPctStake: StatsAverage;
  kpi7_dataCoverage?: Maybe<PercentOfTotal>;
  kpi7_dataQuality?: Maybe<PercentOfTotal>;
  kpi7_investeeRevenueGrowth: StatsAverageMedianPctl25Pctl75;
  kpi7_investeeRevenueGrowth_byBusinessStage?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byGeoMarket?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byInstrument?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byInvestmentTerms?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byProviderType?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byRegion?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi7_leastDevelopedCountries: PercentOfTotal;
  kpi7_marketSaturation: PercentOfTotal;
  kpi7_missingData?: Maybe<PercentOfTotal>;
  msmesFinancedResponsibly_companyImpact: StatsAverageMedian;
  msmesFinancedResponsibly_investmentImpact: StatsAverageMedian;
  msmesFinancedResponsibly_yearChange: StatsAverageDistributionMedian;
  numberOfFunds: Scalars['Int']['output'];
  numberOfInvestees: Scalars['Int']['output'];
  numberOfObservations?: Maybe<Scalars['Int']['output']>;
  numberOfOrgs: Scalars['Int']['output'];
  proportionTargetingStrategicGoal: PercentOfTotal;
  proportionTargetingStrategicGoal_byCompany: PercentOfTotal;
  reportingPeriod: ExtentsInt;
  sdgTargetedThroughFinacialInclusion: PercentOfTotal;
  sdgTargetedThroughFinacialInclusion_byCompany: PercentOfTotal;
  stageOfBusiness?: Maybe<PercentOfTotal>;
  targetFinancialReturn_byCompany: PercentOfTotal;
  targetFinancialReturns: PercentOfTotal;
  test: StatsAverageTrimmedavgValues;
  typesOfFinancialServiceProviders?: Maybe<PercentOfTotal>;
  womenDecentJobs_yearChange: StatsAverageDistributionMedian;
  womenUsingRFS_yearChange: StatsAverageDistributionMedian;
};


export type FinanceIndicatorsClientSatisfactionRatio_CompanyImpactArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};


export type FinanceIndicatorsClientSatisfactionRatio_InvestmentImpactArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};


export type FinanceIndicatorsClientSatisfactionRatio_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};


export type FinanceIndicatorsClientsUsingRfs_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
  withWomenData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsDecentJobs_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
  withWomenData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsKpi1_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsKpi1_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi1_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi1_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi1_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi1_UsingRfs_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi1_UsingRfs_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi1_UsingRfs_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi2_BasicServices_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi2_BasicServices_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi2_BasicServices_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi2_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsKpi2_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi2_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi2_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi2_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi4_Satisfaction_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsKpi5_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsKpi5_Msmes_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi5_Msmes_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi5_Msmes_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi5_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi5_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi5_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi5_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi6_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsKpi6_DecentJobs_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi6_DecentJobs_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi6_DecentJobs_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type FinanceIndicatorsKpi6_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi6_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi6_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi6_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type FinanceIndicatorsKpi7_InvesteeRevenueGrowthArgs = {
  geoMarket?: InputMaybe<GeoMarketEnum>;
};


export type FinanceIndicatorsKpi7_InvesteeRevenueGrowth_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinanceIndicatorsMsmesFinancedResponsibly_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};

export type ForestryIndicators = {
  __typename?: 'ForestryIndicators';
  assetClass: PercentOfTotal;
  assetsUnderManagement: StatsAverageMedian;
  certifications: PercentOfTotal;
  dataConfidence_beneficiaries: PercentOfTotal;
  dataConfidence_emissions: PercentOfTotal;
  dataConfidence_land: PercentOfTotal;
  dataConfidence_protection: PercentOfTotal;
  dataConfidence_revenue: PercentOfTotal;
  datasetName: Scalars['String']['output'];
  decentJobs: StatsAverageMedianTrimmedavg;
  decentJobs_n: StatsAverageMedianTrimmedavg;
  decentJobs_pace: StatsAverageMedianTrimmedavg;
  decentJobs_pacePct: StatsAverageMedianTrimmedavg;
  ecoRegion: PercentOfTotal;
  emissionsRemoved: StatsAverageMedianTrimmedavg;
  emissionsRemoved_n: StatsAverageMedianTrimmedavg;
  emissionsRemoved_pace: StatsAverageMedianTrimmedavg;
  emissionsRemoved_pacePct: StatsAverageMedianTrimmedavg;
  emissionsScope1: StatsAverageMedianTrimmedavg;
  emissionsScope1_n: StatsAverageMedianTrimmedavg;
  emissionsScope1_pace: StatsAverageMedianTrimmedavg;
  emissionsScope1n2: StatsAverageMedianTrimmedavg;
  emissionsScope1n2_n: StatsAverageMedianTrimmedavg;
  emissionsScope1n2_pace: StatsAverageMedianTrimmedavg;
  emissionsScope1n2_pacePct: StatsAverageMedianTrimmedavg;
  emissionsScope2: StatsAverageMedianTrimmedavg;
  emissionsScope2_n: StatsAverageMedianTrimmedavg;
  emissionsScope2_pace: StatsAverageMedianTrimmedavg;
  emissionsScope3: StatsAverageMedianTrimmedavg;
  emissionsScope3_n: StatsAverageMedianTrimmedavg;
  emissionsScope3_pace: StatsAverageMedianTrimmedavg;
  forestBeneficiaries: StatsAverageMedianTrimmedavg;
  forestBeneficiaries_n: StatsAverageMedianTrimmedavg;
  forestBeneficiaries_pace: StatsAverageMedianTrimmedavg;
  forestType: PercentOfTotal;
  geographicFocus: PercentOfTotal;
  hasCertifications: PercentOfTotal;
  impactStrategy: PercentOfTotal;
  incomeGroup: PercentOfTotal;
  investeeRevenueGrowth: StatsAverageMedianTrimmedavg;
  landManaged: StatsAverageMedianTrimmedavg;
  landManaged_n: StatsAverageMedianTrimmedavg;
  landManaged_pace: StatsAverageMedianTrimmedavg;
  numberOfFunds: Scalars['Int']['output'];
  numberOfInvestees: Scalars['Int']['output'];
  numberOfObservations?: Maybe<Scalars['Int']['output']>;
  numberOfOrgs: Scalars['Int']['output'];
  pctLandCertified: StatsAverageMedian;
  pctLandProtected: StatsAverageMedianTrimmedavg;
  pctLandRestored: StatsAverageMedianTrimmedavg;
  primaryCountryByRegion: PercentOfTotalWithSubCount;
  reportingPeriod: ExtentsInt;
  sdgs: PercentOfTotal;
  sdgsTargeted: PercentOfTotal;
  stageOfBusiness: PercentOfTotal;
  stageOfBusiness_uniqueOrg: PercentOfTotal;
  strategicGoals: PercentOfTotal;
  targetFinancialReturns: PercentOfTotal;
  yearsSinceInvestment: PercentOfTotal;
};

export enum GeoFocusEnum {
  Rural = 'Rural',
  Urban = 'Urban'
}

export enum GeoMarketEnum {
  Ldc = 'LDC',
  NotLdc = 'NotLDC'
}

export enum GroupByEnum {
  Country = 'country',
  None = 'none',
  Region = 'region'
}

export type GroupStats = {
  __typename?: 'GroupStats';
  items: Array<Maybe<GroupStatsItem>>;
};

export type GroupStatsAverage = {
  __typename?: 'GroupStatsAverage';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  n: Scalars['Int']['output'];
};

export type GroupStatsAverageDistributionMedian = {
  __typename?: 'GroupStatsAverageDistributionMedian';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type GroupStatsAverageDistributionMedianObservationsPctl25Pctl75Trimmedavg = {
  __typename?: 'GroupStatsAverageDistributionMedianObservationsPctl25Pctl75Trimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  observations?: Maybe<Array<Maybe<ObservationValue>>>;
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsAverageDistributionMedianPctl25Pctl75 = {
  __typename?: 'GroupStatsAverageDistributionMedianPctl25Pctl75';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsAverageDistributionMedianPctl25Pctl75Trimmedavg = {
  __typename?: 'GroupStatsAverageDistributionMedianPctl25Pctl75Trimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen = {
  __typename?: 'GroupStatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen = {
  __typename?: 'GroupStatsAverageDistributionMedianPctl25Pctl75Uniquen';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsAverageDistributionMedianTrimmedavg = {
  __typename?: 'GroupStatsAverageDistributionMedianTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsAverageMedian = {
  __typename?: 'GroupStatsAverageMedian';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type GroupStatsAverageMedianPctl25Pctl75 = {
  __typename?: 'GroupStatsAverageMedianPctl25Pctl75';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsAverageMedianPctl25Pctl75Trimmedavg = {
  __typename?: 'GroupStatsAverageMedianPctl25Pctl75Trimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsAverageMedianTrimmedavg = {
  __typename?: 'GroupStatsAverageMedianTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsAverageMedianTrimmedavgUniquen = {
  __typename?: 'GroupStatsAverageMedianTrimmedavgUniquen';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsAverageMedianTrimmedavgValues = {
  __typename?: 'GroupStatsAverageMedianTrimmedavgValues';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  values: Array<Maybe<Scalars['JSON']['output']>>;
};

export type GroupStatsAverageMedianUniquen = {
  __typename?: 'GroupStatsAverageMedianUniquen';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsAverageMedianValues = {
  __typename?: 'GroupStatsAverageMedianValues';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  values: Array<Maybe<Scalars['JSON']['output']>>;
};

export type GroupStatsAverageTrimmedavg = {
  __typename?: 'GroupStatsAverageTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsDistributionMedianTrimmedavg = {
  __typename?: 'GroupStatsDistributionMedianTrimmedavg';
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsItem = {
  __typename?: 'GroupStatsItem';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type GroupStatsMedian = {
  __typename?: 'GroupStatsMedian';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type GroupStatsMedianTrimmedavg = {
  __typename?: 'GroupStatsMedianTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type GroupStatsMedianUniquen = {
  __typename?: 'GroupStatsMedianUniquen';
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsUniquen = {
  __typename?: 'GroupStatsUniquen';
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  n: Scalars['Int']['output'];
  uniqueN: Scalars['Int']['output'];
};

export type GroupStatsUniquenPctn = {
  __typename?: 'GroupStatsUniquenPctn';
  isDataSuppressed: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  n: Scalars['Int']['output'];
  pctN?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type HealthcareIndicators = {
  __typename?: 'HealthcareIndicators';
  assetClass: PercentOfTotal;
  assetsUnderManagement: StatsAverageMedian;
  certifications: PercentOfTotal;
  dataConfidence_jobs: PercentOfTotal;
  dataConfidence_newAccess: PercentOfTotal;
  dataConfidence_revenue: PercentOfTotal;
  dataConfidence_treated: PercentOfTotal;
  datasetName: Scalars['String']['output'];
  decentJobs: StatsAverageMedianTrimmedavg;
  decentJobs_n: StatsAverageMedianTrimmedavg;
  decentJobs_pace: StatsAverageMedianTrimmedavg;
  decentJobs_pacePct: StatsAverageMedianTrimmedavg;
  diseaseAddressed: PercentOfTotal;
  geographicFocus: PercentOfTotal;
  hasCertifications: PercentOfTotal;
  incomeGroup: PercentOfTotal;
  investeeRevenueGrowth: StatsAverageMedianTrimmedavg;
  netPromoterScore: StatsAverageMedianTrimmedavg;
  numberOfFunds: Scalars['Int']['output'];
  numberOfInvestees: Scalars['Int']['output'];
  numberOfObservations?: Maybe<Scalars['Int']['output']>;
  numberOfOrgs: Scalars['Int']['output'];
  patientsReceivingNewAccess: StatsAverageMedianTrimmedavg;
  patientsReceivingNewAccess_n: StatsAverageMedianTrimmedavg;
  patientsReceivingNewAccess_pace: StatsAverageMedianTrimmedavg;
  patientsReceivingNewAccess_pacePct: StatsAverageMedianTrimmedavg;
  patientsSavingPremium: StatsAverageMedianTrimmedavg;
  patientsTreated: StatsAverageMedianTrimmedavg;
  patientsTreated_n: StatsAverageMedianTrimmedavg;
  patientsTreated_pace: StatsAverageMedianTrimmedavg;
  patientsTreated_pacePct: StatsAverageMedianTrimmedavg;
  pctEmployeesTrained: StatsAverageMedianTrimmedavg;
  primaryCountryByRegion: PercentOfTotalWithSubCount;
  productType: PercentOfTotal;
  reportingPeriod: ExtentsInt;
  sdgs: PercentOfTotal;
  settingOfCare: PercentOfTotal;
  stageOfBusiness: PercentOfTotal;
  stageValueChain: PercentOfTotal;
  strategicGoals: PercentOfTotal;
  targetFinancialReturns: PercentOfTotal;
  targetStakeholder: PercentOfTotal;
  yearsSinceInvestment: PercentOfTotal;
};

export type Indicators = {
  __typename?: 'Indicators';
  assetClass: PercentOfTotal;
  assetClass_byCompany: PercentOfTotal;
  assetsUnderManagement: StatsAverageMedian;
  clientSatisfactionRatio_companyImpact: StatsAverageMedian;
  clientSatisfactionRatio_investmentImpact: StatsAverageMedian;
  clientSatisfactionRatio_yearChange: StatsAverageDistributionMedian;
  clientsAccessingBasicServices_companyImpact: StatsAverageMedian;
  clientsAccessingBasicServices_investmentImpact: StatsAverageMedian;
  clientsAccessingBasicServices_yearChange: StatsAverageDistributionMedian;
  clientsUsingRFS_companyImpact: StatsAverageMedian;
  clientsUsingRFS_investmentImpact: StatsAverageMedian;
  clientsUsingRFS_yearChange: StatsAverageDistributionMedianPctl25Pctl75;
  countByBucketsSinceInvestment: ValueCount;
  countByBusinessStage: ValueCount;
  countByInstrument: ValueCount;
  countByInvesteeEngagement: ValueCount;
  countByInvestmentTerms: ValueCount;
  countByProviderType: ValueCount;
  countByRegion: ValueCount;
  countByStakeholderEngagement: ValueCount;
  countByYearsSinceInvestment: ValueCount;
  datasetName: Scalars['String']['output'];
  decentJobs_companyImpact: StatsAverageMedian;
  decentJobs_investmentImpact: StatsAverageMedian;
  decentJobs_yearChange: StatsAverageDistributionMedian;
  icRacePct: StatsAverage;
  icWomenPct: StatsAverage;
  investeeCountries?: Maybe<PercentOfTotal>;
  investeeRevenueGrowth_companyImpact: StatsAverageMedian;
  investeeRevenueGrowth_investmentImpact: StatsAverageMedian;
  investeeRevenueGrowth_yearChange: StatsAverageDistributionMedian;
  investorHeadquartersLocation: PercentOfTotal;
  kpi1_clients: StatsAverageMedian;
  kpi1_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi1_dataCoverage?: Maybe<PercentOfTotal>;
  kpi1_dataQuality?: Maybe<PercentOfTotal>;
  kpi1_missingData?: Maybe<PercentOfTotal>;
  kpi1_paceCo: StatsAverageMedianPctl25Pctl75;
  kpi1_paceN: StatsAverageMedianPctl25Pctl75;
  kpi1_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi1_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi1_pace_byInstrument?: Maybe<GroupStats>;
  kpi1_pace_byProviderType?: Maybe<GroupStats>;
  kpi1_pace_byRegion?: Maybe<GroupStats>;
  kpi1_usingRFS_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi1_usingRFS_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi1_usingRFS_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi1_weightedClients: StatsAverageMedian;
  kpi1_weightedPctStake: StatsAverage;
  kpi2_basicServices_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi2_basicServices_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi2_basicServices_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi2_clients: StatsAverageMedian;
  kpi2_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi2_dataCoverage?: Maybe<PercentOfTotal>;
  kpi2_dataQuality?: Maybe<PercentOfTotal>;
  kpi2_missingData?: Maybe<PercentOfTotal>;
  kpi2_paceCo: StatsAverageMedianPctl25Pctl75;
  kpi2_paceN: StatsAverageMedianPctl25Pctl75;
  kpi2_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi2_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi2_pace_byInstrument?: Maybe<GroupStats>;
  kpi2_pace_byProviderType?: Maybe<GroupStats>;
  kpi2_pace_byRegion?: Maybe<GroupStats>;
  kpi2_weightedClients: StatsAverageMedian;
  kpi2_weightedPctStake: StatsAverage;
  kpi3_dataCoverage?: Maybe<PercentOfTotal>;
  kpi3_dataQuality?: Maybe<PercentOfTotal>;
  kpi3_missingData?: Maybe<PercentOfTotal>;
  kpi4_dataCoverage?: Maybe<PercentOfTotal>;
  kpi4_dataQuality?: Maybe<PercentOfTotal>;
  kpi4_missingData?: Maybe<PercentOfTotal>;
  kpi4_satisfaction: StatsAverageMedianPctl25Pctl75;
  kpi4_satisfaction_buckets: ValueCount;
  kpi4_satisfaction_byBusinessStage?: Maybe<GroupStats>;
  kpi4_satisfaction_byInstrument?: Maybe<GroupStats>;
  kpi4_satisfaction_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi4_satisfaction_byProviderType?: Maybe<GroupStats>;
  kpi4_satisfaction_byRegion?: Maybe<GroupStats>;
  kpi4_satisfaction_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi4_satisfaction_byTerms?: Maybe<GroupStats>;
  kpi4_satisfaction_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi5_clients: StatsAverageMedian;
  kpi5_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi5_dataCoverage?: Maybe<PercentOfTotal>;
  kpi5_dataQuality?: Maybe<PercentOfTotal>;
  kpi5_missingData?: Maybe<PercentOfTotal>;
  kpi5_msmes_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi5_msmes_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi5_msmes_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi5_paceN: StatsAverageMedianPctl25Pctl75;
  kpi5_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi5_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi5_pace_byInstrument?: Maybe<GroupStats>;
  kpi5_pace_byProviderType?: Maybe<GroupStats>;
  kpi5_pace_byRegion?: Maybe<GroupStats>;
  kpi5_weightedClients: StatsAverageMedian;
  kpi5_weightedPctStake: StatsAverage;
  kpi6_clients_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi6_dataCoverage?: Maybe<PercentOfTotal>;
  kpi6_dataQuality?: Maybe<PercentOfTotal>;
  kpi6_decentJobs: StatsAverageMedian;
  kpi6_decentJobs_pace_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi6_decentJobs_pace_byInvestmentTerms?: Maybe<GroupStats>;
  kpi6_decentJobs_pace_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi6_missingData?: Maybe<PercentOfTotal>;
  kpi6_paceCo: StatsAverageMedianPctl25Pctl75;
  kpi6_paceN: StatsAverageMedianPctl25Pctl75;
  kpi6_pacePct: StatsAverageMedianPctl25Pctl75;
  kpi6_pace_byBusinessStage?: Maybe<GroupStats>;
  kpi6_pace_byInstrument?: Maybe<GroupStats>;
  kpi6_pace_byProviderType?: Maybe<GroupStats>;
  kpi6_pace_byRegion?: Maybe<GroupStats>;
  kpi6_weightedJobs: StatsAverageMedian;
  kpi6_weightedPctStake: StatsAverage;
  kpi7_dataCoverage?: Maybe<PercentOfTotal>;
  kpi7_dataQuality?: Maybe<PercentOfTotal>;
  kpi7_investeeRevenueGrowth: StatsAverageMedianPctl25Pctl75;
  kpi7_investeeRevenueGrowth_byBusinessStage?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byGeoMarket?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byInstrument?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byInvesteeEngagement?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byInvestmentTerms?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byProviderType?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byRegion?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_byStakeholderEngagement?: Maybe<GroupStats>;
  kpi7_investeeRevenueGrowth_yearsSinceInvestment?: Maybe<GroupStats>;
  kpi7_leastDevelopedCountries: PercentOfTotal;
  kpi7_marketSaturation: PercentOfTotal;
  kpi7_missingData?: Maybe<PercentOfTotal>;
  msmesFinancedResponsibly_companyImpact: StatsAverageMedian;
  msmesFinancedResponsibly_investmentImpact: StatsAverageMedian;
  msmesFinancedResponsibly_yearChange: StatsAverageDistributionMedian;
  numberOfFunds: Scalars['Int']['output'];
  numberOfInvestees: Scalars['Int']['output'];
  numberOfObservations?: Maybe<Scalars['Int']['output']>;
  numberOfOrgs: Scalars['Int']['output'];
  proportionTargetingStrategicGoal: PercentOfTotal;
  proportionTargetingStrategicGoal_byCompany: PercentOfTotal;
  reportingPeriod: ExtentsInt;
  sdgTargetedThroughFinacialInclusion: PercentOfTotal;
  sdgTargetedThroughFinacialInclusion_byCompany: PercentOfTotal;
  stageOfBusiness?: Maybe<PercentOfTotal>;
  targetFinancialReturn_byCompany: PercentOfTotal;
  targetFinancialReturns: PercentOfTotal;
  test: StatsAverageTrimmedavgValues;
  typesOfFinancialServiceProviders?: Maybe<PercentOfTotal>;
  womenDecentJobs_yearChange: StatsAverageDistributionMedian;
  womenUsingRFS_yearChange: StatsAverageDistributionMedian;
};


export type IndicatorsClientSatisfactionRatio_CompanyImpactArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};


export type IndicatorsClientSatisfactionRatio_InvestmentImpactArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};


export type IndicatorsClientSatisfactionRatio_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};


export type IndicatorsClientsUsingRfs_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
  withWomenData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsDecentJobs_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
  withWomenData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsKpi1_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsKpi1_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi1_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi1_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi1_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi1_UsingRfs_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi1_UsingRfs_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi1_UsingRfs_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi2_BasicServices_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi2_BasicServices_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi2_BasicServices_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi2_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsKpi2_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi2_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi2_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi2_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi4_Satisfaction_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsKpi5_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsKpi5_Msmes_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi5_Msmes_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi5_Msmes_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi5_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi5_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi5_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi5_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi6_Clients_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsKpi6_DecentJobs_Pace_ByInvesteeEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi6_DecentJobs_Pace_ByInvestmentTermsArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi6_DecentJobs_Pace_ByStakeholderEngagementArgs = {
  value?: InputMaybe<ValueEnum>;
};


export type IndicatorsKpi6_Pace_ByBusinessStageArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi6_Pace_ByInstrumentArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi6_Pace_ByProviderTypeArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi6_Pace_ByRegionArgs = {
  level?: InputMaybe<LevelEnum>;
};


export type IndicatorsKpi7_InvesteeRevenueGrowthArgs = {
  geoMarket?: InputMaybe<GeoMarketEnum>;
};


export type IndicatorsKpi7_InvesteeRevenueGrowth_YearsSinceInvestmentArgs = {
  bucketed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IndicatorsMsmesFinancedResponsibly_YearChangeArgs = {
  geoFocus?: InputMaybe<GeoFocusEnum>;
};

export enum LevelEnum {
  Company = 'Company'
}

export type ObservationValue = {
  __typename?: 'ObservationValue';
  id: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationDatasets = {
  __typename?: 'OrganizationDatasets';
  datasets: Array<Scalars['String']['output']>;
  externalKey: Scalars['String']['output'];
};

export type PercentOfTotal = {
  __typename?: 'PercentOfTotal';
  isDataSuppressed: Scalars['Boolean']['output'];
  items: Array<Maybe<PercentOfTotalItem>>;
  n: Scalars['Int']['output'];
};

export type PercentOfTotalItem = {
  __typename?: 'PercentOfTotalItem';
  count: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  pct: Scalars['Float']['output'];
};

export type PercentOfTotalItemWithSubCount = {
  __typename?: 'PercentOfTotalItemWithSubCount';
  count: Scalars['Int']['output'];
  items: Array<Maybe<PercentOfTotalItem>>;
  label?: Maybe<Scalars['String']['output']>;
  pct: Scalars['Float']['output'];
};

export type PercentOfTotalWithSubCount = {
  __typename?: 'PercentOfTotalWithSubCount';
  isDataSuppressed: Scalars['Boolean']['output'];
  items: Array<Maybe<PercentOfTotalItemWithSubCount>>;
  n: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  agricultureIndicators?: Maybe<AgricultureIndicators>;
  energyIndicators?: Maybe<EnergyIndicators>;
  financeIndicators?: Maybe<FinanceIndicators>;
  forestryIndicators?: Maybe<ForestryIndicators>;
  healthcareIndicators?: Maybe<HealthcareIndicators>;
  indicators?: Maybe<Indicators>;
  me?: Maybe<User>;
  organizations: Array<OrganizationDatasets>;
};


export type QueryAgricultureIndicatorsArgs = {
  filter?: InputMaybe<Array<InputMaybe<FilterCond>>>;
};


export type QueryEnergyIndicatorsArgs = {
  filter?: InputMaybe<Array<InputMaybe<FilterCond>>>;
};


export type QueryFinanceIndicatorsArgs = {
  filter?: InputMaybe<Array<InputMaybe<FilterCond>>>;
};


export type QueryForestryIndicatorsArgs = {
  filter?: InputMaybe<Array<InputMaybe<FilterCond>>>;
};


export type QueryHealthcareIndicatorsArgs = {
  filter?: InputMaybe<Array<InputMaybe<FilterCond>>>;
};


export type QueryIndicatorsArgs = {
  filter?: InputMaybe<Array<InputMaybe<FilterCond>>>;
};

export type StatsAverage = {
  __typename?: 'StatsAverage';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  n: Scalars['Int']['output'];
};

export type StatsAverageDistributionMedian = {
  __typename?: 'StatsAverageDistributionMedian';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type StatsAverageDistributionMedianObservationsPctl25Pctl75 = {
  __typename?: 'StatsAverageDistributionMedianObservationsPctl25Pctl75';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  observations?: Maybe<Array<Maybe<ObservationValue>>>;
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type StatsAverageDistributionMedianObservationsPctl25Pctl75Trimmedavg = {
  __typename?: 'StatsAverageDistributionMedianObservationsPctl25Pctl75Trimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  observations?: Maybe<Array<Maybe<ObservationValue>>>;
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type StatsAverageDistributionMedianPctl25Pctl75 = {
  __typename?: 'StatsAverageDistributionMedianPctl25Pctl75';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageDistributionMedianPctl25Pctl75Trimmedavg = {
  __typename?: 'StatsAverageDistributionMedianPctl25Pctl75Trimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen = {
  __typename?: 'StatsAverageDistributionMedianPctl25Pctl75TrimmedavgUniquen';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type StatsAverageDistributionMedianPctl25Pctl75Uniquen = {
  __typename?: 'StatsAverageDistributionMedianPctl25Pctl75Uniquen';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type StatsAverageDistributionMedianTrimmedavg = {
  __typename?: 'StatsAverageDistributionMedianTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageMedian = {
  __typename?: 'StatsAverageMedian';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type StatsAverageMedianPctl25Pctl75 = {
  __typename?: 'StatsAverageMedianPctl25Pctl75';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageMedianPctl25Pctl75Trimmedavg = {
  __typename?: 'StatsAverageMedianPctl25Pctl75Trimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  pctl25?: Maybe<Scalars['Float']['output']>;
  pctl75?: Maybe<Scalars['Float']['output']>;
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageMedianTrimmedavg = {
  __typename?: 'StatsAverageMedianTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageMedianTrimmedavgUniquen = {
  __typename?: 'StatsAverageMedianTrimmedavgUniquen';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  uniqueN: Scalars['Int']['output'];
};

export type StatsAverageMedianTrimmedavgValues = {
  __typename?: 'StatsAverageMedianTrimmedavgValues';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  values: Array<Maybe<Scalars['JSON']['output']>>;
};

export type StatsAverageMedianUniquen = {
  __typename?: 'StatsAverageMedianUniquen';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  uniqueN: Scalars['Int']['output'];
};

export type StatsAverageMedianValues = {
  __typename?: 'StatsAverageMedianValues';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  values: Array<Maybe<Scalars['Int']['output']>>;
};

export type StatsAverageTrimmedavg = {
  __typename?: 'StatsAverageTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type StatsAverageTrimmedavgValues = {
  __typename?: 'StatsAverageTrimmedavgValues';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
  values: Array<Maybe<Scalars['JSON']['output']>>;
};

export type StatsDistributionMedian = {
  __typename?: 'StatsDistributionMedian';
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type StatsDistributionMedianTrimmedavg = {
  __typename?: 'StatsDistributionMedianTrimmedavg';
  distribution?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type StatsMedian = {
  __typename?: 'StatsMedian';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
};

export type StatsMedianTrimmedavg = {
  __typename?: 'StatsMedianTrimmedavg';
  average?: Maybe<Scalars['Float']['output']>;
  isDataSuppressed: Scalars['Boolean']['output'];
  median?: Maybe<Scalars['Float']['output']>;
  n: Scalars['Int']['output'];
  trimmedAvg?: Maybe<Scalars['Float']['output']>;
};

export type User = {
  __typename?: 'User';
  irisVersion?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  salesforceAccountId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type ValueCount = {
  __typename?: 'ValueCount';
  isDataSuppressed: Scalars['Boolean']['output'];
  items: Array<Maybe<ValueCountItem>>;
  n: Scalars['Int']['output'];
};

export type ValueCountItem = {
  __typename?: 'ValueCountItem';
  count: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type ValueCountUniqueItem = {
  __typename?: 'ValueCountUniqueItem';
  count: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  unique: Scalars['Int']['output'];
};

export enum ValueEnum {
  Absolute = 'absolute',
  Percent = 'percent'
}

export type GetFilterCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterCountsQuery = { __typename?: 'Query', forestryIndicators?: { __typename?: 'ForestryIndicators', assetClass: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null } | null> }, yearsSinceInvestment: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null } | null> }, stageOfBusiness: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', label?: string | null, count: number } | null> }, incomeGroup: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', label?: string | null, count: number } | null> }, primaryCountryByRegion: { __typename?: 'PercentOfTotalWithSubCount', items: Array<{ __typename?: 'PercentOfTotalItemWithSubCount', label?: string | null, count: number } | null> }, impactStrategy: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', label?: string | null, count: number } | null> }, forestType: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', label?: string | null, count: number } | null> }, ecoRegion: { __typename?: 'PercentOfTotal', items: Array<{ __typename?: 'PercentOfTotalItem', label?: string | null, count: number } | null> } } | null };

export type GetReportingPeriodQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportingPeriodQuery = { __typename?: 'Query', forestryIndicators?: { __typename?: 'ForestryIndicators', reportingPeriod: { __typename?: 'ExtentsInt', min?: number | null, max?: number | null } } | null };

export type ValidateFiltersQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<FilterCond>> | InputMaybe<FilterCond>>;
}>;


export type ValidateFiltersQuery = { __typename?: 'Query', forestryIndicators?: { __typename?: 'ForestryIndicators', numberOfOrgs: number } | null };

export type GetViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerQuery = { __typename?: 'Query', me?: { __typename?: 'User', irisVersion?: string | null, orgId?: string | null, salesforceAccountId?: string | null, userId: string, userName?: string | null } | null };

export type KpiImpact_DecentJobsFragmentFragment = { __typename?: 'ForestryIndicators', decentJobs: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, decentJobs_n: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, decentJobs_pace: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_DecentJobsFragmentFragment' };

export type KpiImpact_EmissionRemovedFragmentFragment = { __typename?: 'ForestryIndicators', emissionsScope1n2: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, emissionsScope1n2_n: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, emissionsScope1n2_pace: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_EmissionRemovedFragmentFragment' };

export type KpiImpact_EmissionsRemovedFragmentFragment = { __typename?: 'ForestryIndicators', emissionsRemoved: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, emissionsRemoved_n: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, emissionsRemoved_pace: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_EmissionsRemovedFragmentFragment' };

export type KpiImpact_ForestBeneficiariesFragmentFragment = { __typename?: 'ForestryIndicators', forestBeneficiaries: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, forestBeneficiaries_n: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, forestBeneficiaries_pace: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_ForestBeneficiariesFragmentFragment' };

export type KpiImpact_InvesteeRevenueGrowthFragmentFragment = { __typename?: 'ForestryIndicators', investeeRevenueGrowth: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_InvesteeRevenueGrowthFragmentFragment' };

export type KpiImpact_LandManagedFragmentFragment = { __typename?: 'ForestryIndicators', landManaged: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, landManaged_n: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean }, landManaged_pace: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_LandManagedFragmentFragment' };

export type KpiImpact_LandProtectedFragmentFragment = { __typename?: 'ForestryIndicators', pctLandProtected: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_LandProtectedFragmentFragment' };

export type KpiImpact_LandRestoredFragmentFragment = { __typename?: 'ForestryIndicators', pctLandRestored: { __typename?: 'StatsAverageMedianTrimmedavg', trimmedAvg?: number | null, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'KpiImpact_LandRestoredFragmentFragment' };

export type ImpactKpisPageQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<FilterCond>> | InputMaybe<FilterCond>>;
}>;


export type ImpactKpisPageQuery = { __typename?: 'Query', forestryIndicators?: (
    { __typename?: 'ForestryIndicators' }
    & { ' $fragmentRefs'?: { 'KpiImpact_LandManagedFragmentFragment': KpiImpact_LandManagedFragmentFragment;'KpiImpact_LandProtectedFragmentFragment': KpiImpact_LandProtectedFragmentFragment;'KpiImpact_LandRestoredFragmentFragment': KpiImpact_LandRestoredFragmentFragment;'KpiImpact_EmissionsRemovedFragmentFragment': KpiImpact_EmissionsRemovedFragmentFragment;'KpiImpact_EmissionRemovedFragmentFragment': KpiImpact_EmissionRemovedFragmentFragment;'KpiImpact_ForestBeneficiariesFragmentFragment': KpiImpact_ForestBeneficiariesFragmentFragment;'KpiImpact_DecentJobsFragmentFragment': KpiImpact_DecentJobsFragmentFragment;'KpiImpact_InvesteeRevenueGrowthFragmentFragment': KpiImpact_InvesteeRevenueGrowthFragmentFragment } }
  ) | null };

export type Index_AssetClassFragmentFragment = { __typename?: 'ForestryIndicators', assetClass: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_AssetClassFragmentFragment' };

export type Index_AssetsUnderManagementFragmentFragment = { __typename?: 'ForestryIndicators', assetsUnderManagement: { __typename?: 'StatsAverageMedian', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Index_AssetsUnderManagementFragmentFragment' };

export type Index_CertificationsPresentFragmentFragment = { __typename?: 'ForestryIndicators', certifications: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_CertificationsPresentFragmentFragment' };

export type Index_CountryIncomeGroupFragmentFragment = { __typename?: 'ForestryIndicators', incomeGroup: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_CountryIncomeGroupFragmentFragment' };

export type Index_EcoregionFragmentFragment = { __typename?: 'ForestryIndicators', ecoRegion: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_EcoregionFragmentFragment' };

export type Index_FinancialReturnsFragmentFragment = { __typename?: 'ForestryIndicators', targetFinancialReturns: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_FinancialReturnsFragmentFragment' };

export type Index_GeographicFocusFragmentFragment = { __typename?: 'ForestryIndicators', geographicFocus: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_GeographicFocusFragmentFragment' };

export type Index_ImpactStrategyFragmentFragment = { __typename?: 'ForestryIndicators', impactStrategy: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_ImpactStrategyFragmentFragment' };

export type Index_InvestmentsRepresentedFragmentFragment = { __typename?: 'ForestryIndicators', numberOfInvestees: number } & { ' $fragmentName'?: 'Index_InvestmentsRepresentedFragmentFragment' };

export type Index_InvestorsRepresentedFragmentFragment = { __typename?: 'ForestryIndicators', numberOfOrgs: number } & { ' $fragmentName'?: 'Index_InvestorsRepresentedFragmentFragment' };

export type Index_PresenceOfCertificationsFragmentFragment = { __typename?: 'ForestryIndicators', hasCertifications: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_PresenceOfCertificationsFragmentFragment' };

export type Index_RegionsAndCountriesFragmentFragment = { __typename?: 'ForestryIndicators', primaryCountryByRegion: { __typename?: 'PercentOfTotalWithSubCount', items: Array<{ __typename?: 'PercentOfTotalItemWithSubCount', count: number, label?: string | null, pct: number, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } | null> } } & { ' $fragmentName'?: 'Index_RegionsAndCountriesFragmentFragment' };

export type Index_SampleSizeFragmentFragment = { __typename?: 'ForestryIndicators', numberOfOrgs: number, numberOfInvestees: number, numberOfObservations?: number | null } & { ' $fragmentName'?: 'Index_SampleSizeFragmentFragment' };

export type Index_StageOfBusinessFragmentFragment = { __typename?: 'ForestryIndicators', stageOfBusiness: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_StageOfBusinessFragmentFragment' };

export type Index_StrategicDevelopmentGoalsFragmentFragment = { __typename?: 'ForestryIndicators', sdgsTargeted: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_StrategicDevelopmentGoalsFragmentFragment' };

export type Index_StrategicGoalsFragmentFragment = { __typename?: 'ForestryIndicators', strategicGoals: { __typename?: 'PercentOfTotal', isDataSuppressed: boolean, items: Array<{ __typename?: 'PercentOfTotalItem', count: number, label?: string | null, pct: number } | null> } } & { ' $fragmentName'?: 'Index_StrategicGoalsFragmentFragment' };

export type IndexPageQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<FilterCond>> | InputMaybe<FilterCond>>;
}>;


export type IndexPageQuery = { __typename?: 'Query', forestryIndicators?: (
    { __typename?: 'ForestryIndicators' }
    & { ' $fragmentRefs'?: { 'Index_FinancialReturnsFragmentFragment': Index_FinancialReturnsFragmentFragment;'Index_SampleSizeFragmentFragment': Index_SampleSizeFragmentFragment;'Index_AssetClassFragmentFragment': Index_AssetClassFragmentFragment;'Index_GeographicFocusFragmentFragment': Index_GeographicFocusFragmentFragment;'Index_StageOfBusinessFragmentFragment': Index_StageOfBusinessFragmentFragment;'Index_EcoregionFragmentFragment': Index_EcoregionFragmentFragment;'Index_PresenceOfCertificationsFragmentFragment': Index_PresenceOfCertificationsFragmentFragment;'Index_ImpactStrategyFragmentFragment': Index_ImpactStrategyFragmentFragment;'Index_CountryIncomeGroupFragmentFragment': Index_CountryIncomeGroupFragmentFragment;'Index_CertificationsPresentFragmentFragment': Index_CertificationsPresentFragmentFragment;'Index_StrategicGoalsFragmentFragment': Index_StrategicGoalsFragmentFragment;'Index_AssetsUnderManagementFragmentFragment': Index_AssetsUnderManagementFragmentFragment;'Index_StrategicDevelopmentGoalsFragmentFragment': Index_StrategicDevelopmentGoalsFragmentFragment;'Index_RegionsAndCountriesFragmentFragment': Index_RegionsAndCountriesFragmentFragment } }
  ) | null };

export type Sdg_DecentJobsFragmentFragment = { __typename?: 'ForestryIndicators', decentJobs_pacePct: { __typename?: 'StatsAverageMedianTrimmedavg', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Sdg_DecentJobsFragmentFragment' };

export type Sdg_Emissions1And2RemovedFragmentFragment = { __typename?: 'ForestryIndicators', emissionsScope1n2_pacePct: { __typename?: 'StatsAverageMedianTrimmedavg', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Sdg_Emissions1And2RemovedFragmentFragment' };

export type Sdg_EmissionsRemovedFragmentFragment = { __typename?: 'ForestryIndicators', emissionsRemoved_pacePct: { __typename?: 'StatsAverageMedianTrimmedavg', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Sdg_EmissionsRemovedFragmentFragment' };

export type Sdg_InvesteeRevenueGrowthFragmentFragment = { __typename?: 'ForestryIndicators', investeeRevenueGrowth: { __typename?: 'StatsAverageMedianTrimmedavg', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Sdg_InvesteeRevenueGrowthFragmentFragment' };

export type Sdg_LandCertifiedFragmentFragment = { __typename?: 'ForestryIndicators', pctLandCertified: { __typename?: 'StatsAverageMedian', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Sdg_LandCertifiedFragmentFragment' };

export type Sdg_LandRestoredFragmentFragment = { __typename?: 'ForestryIndicators', pctLandRestored: { __typename?: 'StatsAverageMedianTrimmedavg', average?: number | null, median?: number | null, n: number, isDataSuppressed: boolean } } & { ' $fragmentName'?: 'Sdg_LandRestoredFragmentFragment' };

export type SdgPageQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<FilterCond>> | InputMaybe<FilterCond>>;
}>;


export type SdgPageQuery = { __typename?: 'Query', forestryIndicators?: (
    { __typename?: 'ForestryIndicators' }
    & { ' $fragmentRefs'?: { 'Sdg_LandCertifiedFragmentFragment': Sdg_LandCertifiedFragmentFragment;'Sdg_LandRestoredFragmentFragment': Sdg_LandRestoredFragmentFragment;'Sdg_Emissions1And2RemovedFragmentFragment': Sdg_Emissions1And2RemovedFragmentFragment;'Sdg_EmissionsRemovedFragmentFragment': Sdg_EmissionsRemovedFragmentFragment;'Sdg_DecentJobsFragmentFragment': Sdg_DecentJobsFragmentFragment;'Sdg_InvesteeRevenueGrowthFragmentFragment': Sdg_InvesteeRevenueGrowthFragmentFragment } }
  ) | null };

export const KpiImpact_DecentJobsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_DecentJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decentJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decentJobs_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decentJobs_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_DecentJobsFragmentFragment, unknown>;
export const KpiImpact_EmissionRemovedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_EmissionRemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_EmissionRemovedFragmentFragment, unknown>;
export const KpiImpact_EmissionsRemovedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_EmissionsRemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_EmissionsRemovedFragmentFragment, unknown>;
export const KpiImpact_ForestBeneficiariesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_ForestBeneficiariesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestBeneficiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forestBeneficiaries_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forestBeneficiaries_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_ForestBeneficiariesFragmentFragment, unknown>;
export const KpiImpact_InvesteeRevenueGrowthFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_InvesteeRevenueGrowthFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investeeRevenueGrowth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_InvesteeRevenueGrowthFragmentFragment, unknown>;
export const KpiImpact_LandManagedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_LandManagedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landManaged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landManaged_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landManaged_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_LandManagedFragmentFragment, unknown>;
export const KpiImpact_LandProtectedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_LandProtectedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandProtected"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_LandProtectedFragmentFragment, unknown>;
export const KpiImpact_LandRestoredFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_LandRestoredFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandRestored"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<KpiImpact_LandRestoredFragmentFragment, unknown>;
export const Index_AssetClassFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_AssetClassFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_AssetClassFragmentFragment, unknown>;
export const Index_AssetsUnderManagementFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_AssetsUnderManagementFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetsUnderManagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_AssetsUnderManagementFragmentFragment, unknown>;
export const Index_CertificationsPresentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_CertificationsPresentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_CertificationsPresentFragmentFragment, unknown>;
export const Index_CountryIncomeGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_CountryIncomeGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_CountryIncomeGroupFragmentFragment, unknown>;
export const Index_EcoregionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_EcoregionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ecoRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_EcoregionFragmentFragment, unknown>;
export const Index_FinancialReturnsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_FinancialReturnsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetFinancialReturns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_FinancialReturnsFragmentFragment, unknown>;
export const Index_GeographicFocusFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_GeographicFocusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographicFocus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_GeographicFocusFragmentFragment, unknown>;
export const Index_ImpactStrategyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_ImpactStrategyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impactStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_ImpactStrategyFragmentFragment, unknown>;
export const Index_InvestmentsRepresentedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_InvestmentsRepresentedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfInvestees"}}]}}]} as unknown as DocumentNode<Index_InvestmentsRepresentedFragmentFragment, unknown>;
export const Index_InvestorsRepresentedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_InvestorsRepresentedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfOrgs"}}]}}]} as unknown as DocumentNode<Index_InvestorsRepresentedFragmentFragment, unknown>;
export const Index_PresenceOfCertificationsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_PresenceOfCertificationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_PresenceOfCertificationsFragmentFragment, unknown>;
export const Index_RegionsAndCountriesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_RegionsAndCountriesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryCountryByRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Index_RegionsAndCountriesFragmentFragment, unknown>;
export const Index_SampleSizeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_SampleSizeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfOrgs"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfInvestees"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfObservations"}}]}}]} as unknown as DocumentNode<Index_SampleSizeFragmentFragment, unknown>;
export const Index_StageOfBusinessFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_StageOfBusinessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stageOfBusiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_StageOfBusinessFragmentFragment, unknown>;
export const Index_StrategicDevelopmentGoalsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_StrategicDevelopmentGoalsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sdgsTargeted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_StrategicDevelopmentGoalsFragmentFragment, unknown>;
export const Index_StrategicGoalsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_StrategicGoalsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategicGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Index_StrategicGoalsFragmentFragment, unknown>;
export const Sdg_DecentJobsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_DecentJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decentJobs_pacePct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Sdg_DecentJobsFragmentFragment, unknown>;
export const Sdg_Emissions1And2RemovedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_Emissions1And2RemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2_pacePct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Sdg_Emissions1And2RemovedFragmentFragment, unknown>;
export const Sdg_EmissionsRemovedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_EmissionsRemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved_pacePct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Sdg_EmissionsRemovedFragmentFragment, unknown>;
export const Sdg_InvesteeRevenueGrowthFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_InvesteeRevenueGrowthFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investeeRevenueGrowth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Sdg_InvesteeRevenueGrowthFragmentFragment, unknown>;
export const Sdg_LandCertifiedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_LandCertifiedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandCertified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Sdg_LandCertifiedFragmentFragment, unknown>;
export const Sdg_LandRestoredFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_LandRestoredFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandRestored"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<Sdg_LandRestoredFragmentFragment, unknown>;
export const GetFilterCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilterCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestryIndicators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearsSinceInvestment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stageOfBusiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"incomeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryCountryByRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impactStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"forestType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ecoRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFilterCountsQuery, GetFilterCountsQueryVariables>;
export const GetReportingPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportingPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestryIndicators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportingPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]} as unknown as DocumentNode<GetReportingPeriodQuery, GetReportingPeriodQueryVariables>;
export const ValidateFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterCond"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestryIndicators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfOrgs"}}]}}]}}]} as unknown as DocumentNode<ValidateFiltersQuery, ValidateFiltersQueryVariables>;
export const GetViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetViewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"irisVersion"}},{"kind":"Field","name":{"kind":"Name","value":"orgId"}},{"kind":"Field","name":{"kind":"Name","value":"salesforceAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}}]} as unknown as DocumentNode<GetViewerQuery, GetViewerQueryVariables>;
export const ImpactKpisPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImpactKpisPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterCond"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestryIndicators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_LandManagedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_LandProtectedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_LandRestoredFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_EmissionsRemovedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_EmissionRemovedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_ForestBeneficiariesFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_DecentJobsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"KPIImpact_InvesteeRevenueGrowthFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_LandManagedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landManaged"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landManaged_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"landManaged_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_LandProtectedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandProtected"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_LandRestoredFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandRestored"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_EmissionsRemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_EmissionRemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_ForestBeneficiariesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestBeneficiaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forestBeneficiaries_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"forestBeneficiaries_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_DecentJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decentJobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decentJobs_n"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decentJobs_pace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KPIImpact_InvesteeRevenueGrowthFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investeeRevenueGrowth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trimmedAvg"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<ImpactKpisPageQuery, ImpactKpisPageQueryVariables>;
export const IndexPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IndexPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterCond"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestryIndicators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_FinancialReturnsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_SampleSizeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_AssetClassFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_GeographicFocusFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_StageOfBusinessFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_EcoregionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_PresenceOfCertificationsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_ImpactStrategyFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_CountryIncomeGroupFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_CertificationsPresentFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_StrategicGoalsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_AssetsUnderManagementFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_StrategicDevelopmentGoalsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Index_RegionsAndCountriesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_FinancialReturnsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetFinancialReturns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_SampleSizeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numberOfOrgs"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfInvestees"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfObservations"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_AssetClassFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClass"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_GeographicFocusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographicFocus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_StageOfBusinessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stageOfBusiness"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_EcoregionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ecoRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_PresenceOfCertificationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_ImpactStrategyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impactStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_CountryIncomeGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incomeGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_CertificationsPresentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_StrategicGoalsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strategicGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_AssetsUnderManagementFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetsUnderManagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_StrategicDevelopmentGoalsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sdgsTargeted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Index_RegionsAndCountriesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryCountryByRegion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pct"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IndexPageQuery, IndexPageQueryVariables>;
export const SdgPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SdgPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterCond"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forestryIndicators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sdg_LandCertifiedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sdg_LandRestoredFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sdg_Emissions1And2RemovedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sdg_EmissionsRemovedFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sdg_DecentJobsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Sdg_InvesteeRevenueGrowthFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_LandCertifiedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandCertified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_LandRestoredFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pctLandRestored"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_Emissions1And2RemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsScope1n2_pacePct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_EmissionsRemovedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emissionsRemoved_pacePct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_DecentJobsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decentJobs_pacePct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Sdg_InvesteeRevenueGrowthFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForestryIndicators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investeeRevenueGrowth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"average"}},{"kind":"Field","name":{"kind":"Name","value":"median"}},{"kind":"Field","name":{"kind":"Name","value":"n"}},{"kind":"Field","name":{"kind":"Name","value":"isDataSuppressed"}}]}}]}}]} as unknown as DocumentNode<SdgPageQuery, SdgPageQueryVariables>;